const checkoutErrorMessages = {
  CANNOT_ENABLE_AUTO_TAX: 'Stripe cannot determine the tax regulation. Please correct the billing information',
  PAYMENT_SESSION_IS_TERMINATED: 'Payment session is terminated, please try again',
  CANNOT_SETUP_STRIPE: 'Cannot setup stripe',
  UNEXPECTED_ERROR: 'Something went wrong. Please try to checkout again or contact the Tryb support',
  UNEXPECTED_BILLING_INFO_ERROR: 'Something went wrong. Please try to update the billing information.',
  CUSTOMER_NOT_FOUND: 'Cannot find the customer.',
  USE_ANOTHER_PAYMENT_METHOD: 'Something went wrong. Please try to use another payment method.',
  SHADOW_UPDATE_IN_PAYMENT_REQUEST: 'Please reload the page and try the latest action again.',
};

export default checkoutErrorMessages;
